import { KenticoRulesHelper } from '../KenticoRulesHelper';
import { DecodeHtmlEntity } from '../../utils/DecodeHtmlEntity';
import { FormLabelHelpers } from '../../formcontrols/helpers/FormLabelHelpers';
import { StringHelpers } from '../../helpers/StringHelpers';
import { IField, IFieldValidationRule, IControlValidationRule, IFormFieldDefinition } from '../../interfaces/Fields';
import { IFieldControl } from '../control/create-control';

export class KenticoRulesCreator {

  static mergeFormDefinition(control: IFormFieldDefinition, formDefinitionToMergeWith: any) {
    if (
      control !== undefined &&
      formDefinitionToMergeWith !== undefined &&
      formDefinitionToMergeWith[control.name] !== undefined
    ) {
      let validation = control.validation;
      control = Object.assign(control, formDefinitionToMergeWith[control.name]);
      if (control.validation) {
        control.validation = Object.assign(validation, control.validation);
      }
    }
    return control;
  }

  static handleVisiblity(field: IField, control: IFormFieldDefinition) {
    if (field.properties?.visiblemacro) {
      if (field.properties.visiblemacro['@ismacro']) {
        try {
          const macroFunctionFromKenticoRule = KenticoRulesHelper.getMacroMethodFromKenticoMacroRule(
            field.properties.visiblemacro['#text']
          );

          control.visibilityCondition.push({
            kenticoVisibilityFunction: macroFunctionFromKenticoRule,
            type: 'kentico'
          });
        } catch (err) {
          // skip visibility rule
          // tslint:disable-next-line
          console.log(err);
        }
      }
    } else if (field !== undefined && field["@visible"] === undefined) {
      control.visibilityCondition.push({
        visible: false,
        type: 'visibility'
      });
    } 
  }

  static handleEnabled(field: IField, control: IFieldControl) {
    if (field.properties?.enabledmacro) {
      if (field.properties.enabledmacro['@ismacro']) {
        try {
          const macroFunctionFromKenticoRule = KenticoRulesHelper.getMacroMethodFromKenticoMacroRule(
            field.properties.enabledmacro['#text']
          );

          control.enabledCondition = {
            kenticoMacroFunction: macroFunctionFromKenticoRule,
            type: 'kentico'
          };
        } catch (err) {
          // skip visibility rule
          // tslint:disable-next-line
          console.log(err);
        }
      }
    }
  }

  static handleValidation(field: IField, control: IFieldControl) {
    if (!field['@allowempty'] || field['@allowempty'] === 'false') {
      control.validation.required = {
        error: StringHelpers.formFieldRequiredFieldErrorMessage(FormLabelHelpers.getLabelWithoutAsterisk(field.properties.fieldcaption))
      };
    }

    if (!field.rules || !field.rules.rule) {
      // No extra validation rules configured
      return;
    }

    // Kentico's rules can be of 4 different types (see type definition of IFieldValidationRules)
    let kenticoRules: (string | IFieldValidationRule)[] = [];
    if (typeof field.rules.rule === 'string') {
      kenticoRules = [field.rules.rule];
    } else if (typeof field.rules.rule === 'object') {
      kenticoRules = [field.rules.rule as IFieldValidationRule];
    } else if (Array.isArray(field.rules.rule)) {
      kenticoRules = field.rules.rule;
    }

    let validationRules: IControlValidationRule[] = [];

    kenticoRules.forEach(kenticoRule => {
      try {
        const ruleText = typeof kenticoRule === 'string' ? kenticoRule : kenticoRule['#text'];
        const validationFunctionFromKenticoRule = KenticoRulesHelper.getValidationMethodFromKenticoRule(ruleText);

        validationRules.push({
          error: kenticoRule['@errormsg'] !== undefined ? DecodeHtmlEntity.fromString(kenticoRule['@errormsg']) : field.properties.validationerrormessage || "Error",
          validationFunction: validationFunctionFromKenticoRule
        });
      } catch (err) {
        // skip validation rule
        // tslint:disable-next-line
        console.log(err);
      }
    });

    if (validationRules.length > 0) {
      control.validation.kenticoRules = {
        rules: validationRules,
      };
    }
  }

  static assignKenticoRules(field: IField, control) {
    this.handleValidation(field, control);
    this.handleVisiblity(field, control);
    this.handleEnabled(field, control);
    return control;
  }
}
